<app-logo-spinner label="Signing you up..."></app-logo-spinner>
